var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',_vm._b({directives:[{name:"bem",rawName:"v-bem",value:({
    inline: _vm.inline,
    radio: _vm.as === 'radio',
    checkbox: _vm.as !== 'radio',
    fullWidth: _vm.fullWidth,
    spaceless: _vm.spaceless,
    centered: _vm.centered,
    noShadow: _vm.noShadow,
    noSpacingAround: _vm.noSpacingAround,
  }),expression:"{\n    inline,\n    radio: as === 'radio',\n    checkbox: as !== 'radio',\n    fullWidth,\n    spaceless,\n    centered,\n    noShadow,\n    noSpacingAround,\n  }"}],attrs:{"validation-name":_vm.$attrs['validation-name'] || _vm.label,"label":_vm.elementLabel,"type":_vm.multiple ? 'checkbox' : 'radio'}},'FormulateInput',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }